/* ==========================================================================
   ROOMS · Приміряй образ (sections/rooms-try-look.liquid)
   Подіум по колу: центральна модель крупна, сусіди менші, бліді й трохи розмиті, крайні гаснуть.
   Сторінка прокручується як завжди, стрічка рухається лише вбік: перетягування і свайп (стрічка йде
   за пальцем без затримки, кидок докочує на кілька образів), горизонтальний жест трекпада або колесо
   з Shift, стрілки, клік по моделі, клавіші ← →. Після жесту стрічка плавно доїжджає й стає рівно
   на образ. Якщо образів менше семи, кільце повторює їх (копії без фокусу), щоб модель перескакувала
   з краю на край, коли її не видно.
   «Додати образ у кошик» шле всі речі одним запитом /cart/add.js і оновлює кошик темою
   (подія apps:product-added-to-cart, потім відкриває панель кошика, якщо вона є).
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mod = function (x, m) { return ((x % m) + m) % m; };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var plural = function (n) {
    var a = n % 10, b = n % 100;
    if (a === 1 && b !== 11) return n + ' річ';
    if (a >= 2 && a <= 4 && (b < 12 || b > 14)) return n + ' речі';
    return n + ' речей';
  };

  function init(root) {
    if (root.__roomsTry) root.__roomsTry.destroy();

    var stage = root.querySelector('[data-try-stage]');
    var world = root.querySelector('[data-try-world]');
    var progress = root.querySelector('[data-try-progress]');
    var nEl = root.querySelector('[data-try-n]');
    var nameEl = root.querySelector('[data-try-name]');
    var sets = [].slice.call(root.querySelectorAll('[data-try-set]'));
    var base = [].slice.call(world.querySelectorAll('[data-try-fig]'));
    var N = base.length;
    if (!N) return;

    // кільце з копій
    var M = N > 1 ? N * Math.ceil(7 / N) : 1;
    var figs = base.slice();
    for (var c = N; c < M; c++) {
      var copy = base[c % N].cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('tabindex', '-1');
      copy.removeAttribute('data-shopify-editor-block');
      world.appendChild(copy);
      figs.push(copy);
    }
    var wrap = function (x) { return mod(x + M / 2, M) - M / 2; };

    var target = 0, cur = 0, gapPx = 300, active = -1, activeFig = -1;
    var W = 0, H = 0, visible = true, raf = 0, held = false;

    function measure() {
      W = stage.clientWidth;
      H = stage.clientHeight;
    }

    function snap(n) {
      target = Math.round(n);
      kick();
    }

    function step(n) {
      if (!n || N < 2) return;
      snap(Math.round(target) + n);
    }

    function place(f, d) {
      var a = Math.abs(d), s = d < 0 ? -1 : 1;
      var fw = f.offsetWidth || H * 0.24;
      var gap = Math.max(fw * 1.02, Math.min(W * 0.21, H * 0.36));
      gapPx = gap * 1.06;
      var tx = s * (a <= 1 ? a * gap * 1.06 : gap * 1.06 + (a - 1) * gap * 0.86);
      var sc = 1 - Math.min(a, 3) * 0.12;
      var op = a < 2.2 ? 1 : Math.max(0, 1 - (a - 2.2) * 1.7);
      var bl = reduce ? 0 : Math.max(0, a - 0.6) * 0.9;
      var sat = 1 - Math.min(a, 1) * 0.3;
      f.style.transform = 'translate3d(calc(-50% + ' + tx.toFixed(1) + 'px), 0, 0) scale(' + sc.toFixed(4) + ')';
      f.style.opacity = op.toFixed(3);
      f.style.filter = (bl > 0.05 ? 'blur(' + bl.toFixed(2) + 'px) ' : '') + 'saturate(' + sat.toFixed(3) + ')';
      f.style.zIndex = String(100 - Math.round(a * 10));
      f.style.visibility = op < 0.01 ? 'hidden' : 'visible';
    }

    function setActive(a) {
      active = a;
      if (nEl) nEl.textContent = pad(a + 1);
      if (nameEl) nameEl.textContent = base[a].getAttribute('data-name') || '';
      sets.forEach(function (s, i) {
        var on = i === a;
        s.hidden = !on;
        s.classList.toggle('is-on', on);
      });
      hot(-1);
      syncChat();
    }

    function frame() {
      raf = 0;
      // під пальцем стрічка йде без затримки, після — плавно доїжджає до образу
      if (held || reduce) cur = target;
      else cur += (target - cur) * 0.085;
      if (Math.abs(target - cur) < 0.0005) cur = target;
      for (var j = 0; j < M; j++) place(figs[j], M > 1 ? wrap(j - cur) : 0);
      if (progress) progress.style.width = (N > 1 ? Math.min(1, mod(cur, N) / (N - 1)) * 100 : 100) + '%';
      var af = mod(Math.round(cur), M);
      if (af !== activeFig) {
        activeFig = af;
        figs.forEach(function (f, j) { f.classList.toggle('is-active', j === af); });
      }
      var a = af % N;
      if (a !== active) setActive(a);
      if (cur !== target && visible) raf = requestAnimationFrame(frame);
    }

    function kick() {
      if (!raf && visible) raf = requestAnimationFrame(frame);
    }

    // точки і рядки підсвічують одне одне
    function hot(k) {
      var f = figs[activeFig];
      if (f) [].forEach.call(f.querySelectorAll('[data-try-spot]'), function (s) {
        s.classList.toggle('is-hot', +s.getAttribute('data-try-spot') === k);
      });
      var set = sets[active];
      if (set) [].forEach.call(set.querySelectorAll('[data-try-item]'), function (li) {
        li.classList.toggle('is-hot', +li.getAttribute('data-try-item') === k);
      });
    }

    // віджет «написати нам» у правому нижньому куті не повинен лягати на кнопку образу: ховаємо його,
    // поки кнопка в нижніх 220px екрана
    var chatHidden = null;
    function syncChat() {
      var set = sets[active];
      var b = set && set.querySelector('[data-try-buy]');
      var v = false;
      if (b) {
        var r = b.getBoundingClientRect(), vh = window.innerHeight;
        v = r.top < vh && r.bottom > 0 && r.top > vh - 220;
      }
      if (v !== chatHidden) {
        chatHidden = v;
        document.documentElement.classList.toggle('rooms-try-hide-chat', v);
      }
    }

    var off = [];
    function on(el, type, fn, opts) {
      el.addEventListener(type, fn, opts);
      off.push(function () { el.removeEventListener(type, fn, opts); });
    }

    // клік по моделі виводить її в центр, клік по точці гортає список до речі
    var dragged = false;
    on(world, 'click', function (e) {
      var fig = e.target.closest('[data-try-fig]');
      if (!fig || dragged) return;
      var spot = e.target.closest('[data-try-spot]');
      if (spot && fig.classList.contains('is-active')) {
        var k = +spot.getAttribute('data-try-spot');
        hot(k);
        var li = sets[active] && sets[active].querySelector('[data-try-item="' + k + '"]');
        if (li && li.scrollIntoView) li.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduce ? 'auto' : 'smooth' });
        return;
      }
      step(Math.round(wrap(figs.indexOf(fig) - cur)));
    });
    on(world, 'keydown', function (e) {
      var fig = e.target.closest('[data-try-fig]');
      if (!fig || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      step(Math.round(wrap(figs.indexOf(fig) - cur)));
    });
    on(world, 'mouseover', function (e) {
      var s = e.target.closest('[data-try-spot]');
      if (s) hot(+s.getAttribute('data-try-spot'));
    });
    on(world, 'mouseout', function (e) {
      var s = e.target.closest('[data-try-spot]');
      if (s && !s.contains(e.relatedTarget)) hot(-1);
    });

    sets.forEach(function (set) {
      on(set, 'mouseover', function (e) {
        var li = e.target.closest('[data-try-item]');
        if (li) hot(+li.getAttribute('data-try-item'));
      });
      on(set, 'mouseout', function (e) {
        var li = e.target.closest('[data-try-item]');
        if (li && !li.contains(e.relatedTarget)) hot(-1);
      });
      on(set, 'click', function (e) {
        var b = e.target.closest('[data-try-size]');
        if (b) {
          var li = b.closest('[data-try-item]');
          [].forEach.call(li.querySelectorAll('[data-try-size]'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          li.setAttribute('data-variant', b.getAttribute('data-try-size'));
          li.classList.remove('is-missing');
          return;
        }
        var btn = e.target.closest('[data-try-buy]');
        if (btn) buy(set, btn);
      });
    });

    var prev = root.querySelector('[data-try-prev]');
    var next = root.querySelector('[data-try-next]');
    if (prev) on(prev, 'click', function () { step(-1); });
    if (next) on(next, 'click', function () { step(1); });

    // перетягування і свайп: стрічка йде за пальцем, кидок докочує далі
    var px = null, py = 0, from = 0, axis = '', track = [];
    on(stage, 'pointerdown', function (e) {
      if (N < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (e.target.closest('[data-try-spot]')) return;
      px = e.clientX; py = e.clientY; from = cur; axis = ''; track = [[e.timeStamp, e.clientX]];
      dragged = false;
    });
    on(stage, 'pointermove', function (e) {
      if (px === null) return;
      var dx = e.clientX - px, dy = e.clientY - py;
      if (!axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') { px = null; return; }
        held = true; dragged = true;
        root.classList.add('is-dragging');
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      target = from - dx / gapPx;
      track.push([e.timeStamp, e.clientX]);
      if (track.length > 6) track.shift();
      kick();
    });
    function release() {
      if (px === null) return;
      px = null;
      if (!held) return;
      held = false;
      root.classList.remove('is-dragging');
      var a = track[0], b = track[track.length - 1];
      var v = a && b && b[0] > a[0] ? (b[1] - a[1]) / (b[0] - a[0]) : 0; // px за мс
      snap(target - (v * 220) / gapPx);
      setTimeout(function () { dragged = false; }, 0);
    }
    on(stage, 'pointerup', release);
    on(stage, 'pointercancel', release);

    // горизонтальний жест трекпада і колесо з Shift
    var wheelT = 0;
    on(stage, 'wheel', function (e) {
      if (N < 2) return;
      var dx = e.deltaX, dy = e.deltaY;
      if (e.shiftKey && !dx) dx = dy;
      else if (Math.abs(dx) <= Math.abs(dy)) return;
      e.preventDefault();
      var unit = e.deltaMode === 1 ? 32 : e.deltaMode === 2 ? W : 1;
      target += (dx * unit) / (gapPx * 1.6);
      kick();
      clearTimeout(wheelT);
      wheelT = setTimeout(function () { snap(target); }, 140);
    }, { passive: false });

    on(window, 'keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var t = document.activeElement;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      var r = stage.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.6 || r.bottom < window.innerHeight * 0.4) return;
      step(e.key === 'ArrowRight' ? 1 : -1);
    });

    on(window, 'scroll', syncChat, { passive: true });
    on(window, 'resize', function () { measure(); kick(); syncChat(); });

    // поза екраном анімація не крутиться
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) kick();
      });
      io.observe(root);
    }
    [].forEach.call(root.querySelectorAll('img'), function (img) {
      if (!img.complete) on(img, 'load', function () { measure(); kick(); });
    });

    // редактор тем: вибраний блок виходить у центр
    on(document, 'shopify:block:select', function (e) {
      var i = base.indexOf(e.target);
      if (i >= 0) snap(target + Math.round(wrap(i - target)));
    });

    // --- увесь образ у кошик ---
    function buy(set, btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      var msg = set.querySelector('[data-try-msg]');
      var rows = [].slice.call(set.querySelectorAll('[data-try-item]')).filter(function (li) { return !li.hasAttribute('data-sold'); });
      var missing = rows.filter(function (li) { return !li.getAttribute('data-variant'); });
      rows.forEach(function (li) { li.classList.toggle('is-missing', missing.indexOf(li) >= 0); });
      msg.className = 'rooms-try__msg';
      if (!rows.length) { msg.textContent = 'Цих речей уже немає в наявності.'; return; }
      if (missing.length) {
        msg.textContent = 'Оберіть розмір: ' + missing.map(function (li) { return li.getAttribute('data-type'); }).join(', ') + '.';
        if (missing[0].scrollIntoView) missing[0].scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduce ? 'auto' : 'smooth' });
        return;
      }
      var items = rows.map(function (li) { return { id: +li.getAttribute('data-variant'), quantity: 1 }; });
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      btn.setAttribute('aria-busy', 'true');
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        btn.removeAttribute('aria-busy');
        if (!res.ok) {
          msg.textContent = (res.data && (res.data.description || res.data.message)) || 'Не вдалося додати образ. Спробуйте ще раз.';
          return;
        }
        msg.className = 'rooms-try__msg is-ok';
        msg.textContent = 'Образ у кошику: ' + plural(items.length) + '.';
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
        // повторне оновлення страхує від гонки запитів: панель кошика інколи встигала відмалюватися порожньою
        setTimeout(function () { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true })); }, 1500);
        var icon = [].slice.call(document.querySelectorAll('[data-js-cart-icon]')).filter(function (x) { return x.offsetParent !== null; })[0];
        if (icon && document.querySelector('.quick-cart')) setTimeout(function () { icon.click(); }, 350);
      }).catch(function () {
        btn.removeAttribute('aria-busy');
        msg.textContent = 'Немає зʼєднання. Спробуйте ще раз.';
      });
    }

    measure();
    window.addEventListener('load', function () { measure(); kick(); }, { once: true });
    frame();

    root.__roomsTry = {
      destroy: function () {
        off.forEach(function (f) { f(); });
        if (io) io.disconnect();
        clearTimeout(wheelT);
        if (raf) cancelAnimationFrame(raf);
        figs.slice(N).forEach(function (f) { f.remove(); });
        document.documentElement.classList.remove('rooms-try-hide-chat');
        root.__roomsTry = null;
      }
    };
  }

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-rooms-try]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-rooms-try]'), function (r) { if (r.__roomsTry) r.__roomsTry.destroy(); });
  });
})();
